import cx from 'classnames'
import Styles from './RadioGroup.module.scss'
import { RadioBulletProps } from './Types'
import { CSSProperties } from 'react'

export const RadioBullet = ({
  isSelected = false,
  isFocusVisible = false,
  isDisabled = false,
  rightAligned = false,
  noMargin = false,
  size = 16,
  color = 'var(--dark-80)',
}: RadioBulletProps) => (
  <div
    className={cx(Styles.radioButton, {
      [Styles.selected]: isSelected,
      [Styles.focused]: isFocusVisible,
      [Styles.disabled]: isDisabled,
      [Styles.rightAligned]: rightAligned,
      [Styles.noMargin]: noMargin,
    })}
    style={
      {
        width: `${size}px`,
        height: `${size}px`,
        '--radio-size': `${size}px`,
        '--radio-color': color,
      } as CSSProperties
    }
  />
)
